module.exports = __webpack_public_path__ + "assets/img/Sustainable_001_w.2425831a.svg";